export const Others = 0
export const VehicleOrders = 1
export const FreightOrders = 2
export const MyVehicleOrders = 3
export const MyFreightOrders = 4
export const OthersHelpdesk = 7
export const LinkVehicleOrders = 8
export const LinkFreightOrders = 9
export const MyLinkVehicleOrders = 10
export const MyLinkFreightOrders = 11
